var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7701 4H17.5394C18.8988 4 20.0009 5.10207 20.0009 6.46154V18.7692C20.0009 20.1287 18.8988 21.2308 17.5394 21.2308H12.6163V13.8462C12.6163 12.4867 11.5142 11.3846 10.1547 11.3846H8.30859V6.46154C8.30859 5.10207 9.41066 4 10.7701 4ZM10.7691 6.46153H13.2306V8.92307H10.7691V6.46153ZM17.5375 6.46152H15.076V8.92306H17.5375V6.46152ZM15.076 10.7692H17.5375V13.2307H15.076V10.7692ZM17.5375 15.0769H15.076V17.5385H17.5375V15.0769Z",
    fill: "#00B0CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13.8462C4 13.1665 4.55103 12.6154 5.23077 12.6154H10.1538C10.8336 12.6154 11.3846 13.1665 11.3846 13.8462V21.2308H5.23077C4.55103 21.2308 4 20.6798 4 20V13.8462ZM8.30816 15.0769H9.53893V16.3077H8.30816V15.0769ZM7.07626 15.0769H5.84549V16.3077H7.07626V15.0769ZM8.30816 17.5384H9.53893V18.7692H8.30816V17.5384ZM7.07626 17.5384H5.84549V18.7692H7.07626V17.5384Z",
    fill: "#007283"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprise);
export default __webpack_public_path__ + "static/media/Enterprise.900caa170c497ef7da22c5755c1a84b8.svg";
export { ForwardRef as ReactComponent };